import { message } from 'antd';
import { COMPLIANCE_SETTINGS_CRUD_ACTION_CREATORS } from '../actions/compliance_settings_actions';
import { fetchComplianceSummary } from './compliance_request_instances_thunks';
import { fetchComplianceSupplierStatuses } from './compliance_statuses_thunks';
import FetchUtils, { parseJSON } from './fetch_utils';
import { getBackendUri } from '../utils/EnvConfigUtils';
import { logoutSuccess } from '../actions/session_actions';

const fetchUtils = new FetchUtils();

// Proposed backend contract: /api/v1/buyer/compliance/settings — a singleton
// per buyer org, so both thunks are hand-rolled (no /:id path segment).
// The record lives in state.compliance_settings.detail via fetchOneSuccess.

export const fetchComplianceSettings = (userType) => () => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/${userType}/compliance/settings`;
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(COMPLIANCE_SETTINGS_CRUD_ACTION_CREATORS.fetchStart());
			fetchUtils
				.get(baseUrl + apiUrl, {
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
				})
				.then(parseJSON)
				.then(({ json, status }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
						reject('unauthorized');
						return;
					}
					if (d.status === 'error') {
						dispatch(COMPLIANCE_SETTINGS_CRUD_ACTION_CREATORS.fetchError(d.message));
						reject(d.message);
					} else {
						dispatch(COMPLIANCE_SETTINGS_CRUD_ACTION_CREATORS.fetchOneSuccess(d.data));
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(COMPLIANCE_SETTINGS_CRUD_ACTION_CREATORS.fetchError(d.message));
					reject(d.message);
				});
		});
	};
};

export const updateComplianceSettings = (userType) => (settings) => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/${userType}/compliance/settings`;
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(COMPLIANCE_SETTINGS_CRUD_ACTION_CREATORS.updateStart(settings));
			fetchUtils
				.put(baseUrl + apiUrl, {
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
					data: settings,
				})
				.then(parseJSON)
				.then(({ json, status }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
						reject('unauthorized');
						return;
					}
					if (d.status === 'error') {
						dispatch(COMPLIANCE_SETTINGS_CRUD_ACTION_CREATORS.updateError(d.message, settings));
						message.error('Failed to update compliance settings.');
						reject(d.message);
					} else {
						// updateSuccess clears the `updating` flag (drives the modal's DONE
						// spinner); fetchOneSuccess keeps `detail` fresh for the modal.
						dispatch(COMPLIANCE_SETTINGS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
						dispatch(COMPLIANCE_SETTINGS_CRUD_ACTION_CREATORS.fetchOneSuccess(d.data));
						// approvalMode / allowWorkOrdersForNonCompliant re-derive every
						// party's compliance. Proactively refetch the shared derived state
						// (summary banner + supplier party statuses) into redux so every
						// consumer re-renders — no cross-component refresh signal needed.
						dispatch(fetchComplianceSummary(userType)());
						dispatch(fetchComplianceSupplierStatuses(userType)());
						message.success('Compliance settings updated.');
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(COMPLIANCE_SETTINGS_CRUD_ACTION_CREATORS.updateError(d.message, settings));
					message.error('Failed to update compliance settings.');
					reject(d.message);
				});
		});
	};
};
